import RotateAnim from "../../../../../../../src/animation/RotateAnimation";
import { eventBus, EnumEventBus } from "../../../managers/EventBus";


export default function RotateAnimation(rotRadian: number, onUpdate:(r: number) => void): Promise<void>{
	const duration = Math.abs(rotRadian / (Math.PI / 2) * 1000);
	return new Promise(res => {
		const rotateAnim = new RotateAnim(rotRadian, duration, onUpdate, res, res);
		eventBus.on(EnumEventBus.setTracingMode, v => !v ? rotateAnim.isStopped = true : "");
	})
}
